import moment from 'moment'
// import {debounce} from ' lodash'

export function basicInfo (data) {
  const basicInfo = {
    'First Name': data.first_name,
    'Last Name': data.last_name,
    'Date of Birth': moment(data.dob).format('DD-MM-YYYY'),
    'Nationality': data.nationality,
    'Religion': data.religion,
    'Gender': data.gender,
    'Category': data.category,
    'Mother Tongue': data.language,
  }

  return basicInfo
}

export function contactInfo (data) {
  const contactInfo = {
    'Address': data.address,
    'Landmark': data.landmark,
    'Pincode': data.pincode,
    'City': data.city,
    'State': data.state,
    'Country': data.country,
    'Phone': data.phone ? data.country_code + '' + data.phone : '',
    'Alt Phone': data.alt_phone ? data.alt_country_code + '' + data.alt_phone : '',
    'Email': data.email,
  }

  return contactInfo
}

export function academicInfo (data, currentSession) {
  const academicInfo = {
    'Class': data ? data.school_class ? data.school_class.name : '' : '',
    'Section': data ? data.section ? data.section.name : '' : '',
    'Roll No': data ? data.roll_no : '',
    'Session': currentSession.name,
  }

  return academicInfo
}

export function electivesInfo (data) {
  const electivesInfo = {}
  data.forEach(function(item, index) {
    let key = item.pivot.elective_subject
    electivesInfo[key] = item.name
  })

  return electivesInfo
}

export function previousSchoolInfo (data) {
  const previousSchoolInfo = {
    'Previous School': data.previous_school_name,
    'Previous Class': data.previous_class,
    'Previous Board': data.previous_board,
    'Previous Score': data.previous_mark,
  }

  return previousSchoolInfo
}

export function parentInfo (data) {
  const parentInfo = {}
  data.forEach(function(item, index) {
    let key = item.relation.charAt(0).toUpperCase() + item.relation.slice(1)
    parentInfo[key] = item
  })

  return parentInfo
}

export function medicalInfo (data) {
  const medicalInfo = {
    'Blood Group': data.blood_group,
    'Allergies': data.allergies,
    'Major Illness': data.major_illness,
  }

  return medicalInfo
}

// TODO: Need to call api for student type and map the id correspondingly
export function otherInfo (data) {
  const otherInfo = {
    'Student Type': data.student_type_id,
  }
  return otherInfo
}
